import React, { useState } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScienceIcon from "@mui/icons-material/Science";
import BallotIcon from "@mui/icons-material/Ballot";
import BuildIcon from "@mui/icons-material/Build";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import DescriptionIcon from "@mui/icons-material/Description";
import TerrainIcon from "@mui/icons-material/Terrain";
import RuleIcon from "@mui/icons-material/Rule";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import GroupsIcon from "@mui/icons-material/Groups";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import SecurityIcon from "@mui/icons-material/Security";
import "./siteSaas.css";

const WHATSAPP_URL = "https://wa.me/5563992281407?text=Ol%C3%A1%2C%20quero%20conhecer%20a%20Qualinfra.";

const recursos = [
  {
    numero: "01",
    icone: DashboardIcon,
    titulo: "Qualidade centralizada",
    texto: "Procedimentos, registros, documentos, KPIs e não conformidades organizados em um único ambiente.",
  },
  {
    numero: "02",
    icone: CalendarMonthIcon,
    titulo: "Rastreabilidade completa",
    texto: "Histórico de moldagens, rupturas, ensaios, obras, materiais e responsáveis pronto para auditorias.",
  },
  {
    numero: "03",
    icone: DescriptionIcon,
    titulo: "Relatórios padronizados",
    texto: "Laudos profissionais com a identidade visual da sua empresa e dados sempre consistentes.",
  },
  {
    numero: "04",
    icone: GroupsIcon,
    titulo: "Gestão multiunidade",
    texto: "Controle equipes, clientes e obras com acesso seguro e informações separadas por obras.",
  },
  {
    numero: "05",
    icone: CheckCircleIcon,
    titulo: "Fluxos e aprovações",
    texto: "Acompanhe solicitações, pendências e aprovações sem perder prazos ou histórico de decisões.",
  },
  {
    numero: "06",
    icone: QueryStatsIcon,
    titulo: "Decisões por indicadores",
    texto: "Visualize satisfação, resistência, volume de ensaios e não conformidades em painéis objetivos.",
  },
];

const modulos = [
  {
    titulo: "Concreto e laboratório",
    texto: "Do recebimento do concreto ao laudo final, com rastreabilidade por obra e idade.",
    icone: ScienceIcon,
    cor: "azul",
    itens: ["Agenda de ruptura", "Dosagem e guias", "Módulo de elasticidade", "Tração, RAA e extrações"],
  },
  {
    titulo: "Solos e pavimentação",
    texto: "Cadastros técnicos e relatórios consistentes para controle de campo e laboratório.",
    icone: TerrainIcon,
    cor: "verde",
    itens: ["Compactação", "Densidade in situ", "Granulometria", "Adesividade e paver"],
  },
  {
    titulo: "Gestão operacional",
    texto: "A estrutura necessária para conectar equipe, equipamentos, materiais e obras.",
    icone: BuildIcon,
    cor: "laranja",
    itens: ["Obras e clientes", "Materiais e equipamentos", "Calibração de prensas", "Tanque de cura"],
  },
  {
    titulo: "Sistema de gestão",
    texto: "Indicadores, ocorrências e documentos para transformar registros em melhoria contínua.",
    icone: RuleIcon,
    cor: "roxo",
    itens: ["KPIs e pesquisas", "Não conformidades", "Aprovações", "Laudos e documentos"],
  },
];

const planos = [
  {
    nome: "Pessoal",
    descricao: "Para profissionais que precisam de um ambiente individual de gestão e controle.",
    recursos: ["1 único usuário", "Obras, ensaios e SGQ", "Relatórios e rastreabilidade", "Sem usuários adicionais"],
  },
  {
    nome: "Essencial",
    descricao: "Para empresas que estão estruturando a gestão da qualidade.",
    recursos: ["Até 5 usuários", "Até 3 obras ativas", "Logo da empresa nos laudos", "Atendimento via WhatsApp"],
  },
  {
    nome: "Profissional",
    descricao: "Para operações que precisam de controle, escala e produtividade.",
    destaque: true,
    recursos: ["Até 20 usuários", "Até 15 obras ativas", "Indicadores e dashboards", "Atendimento via WhatsApp"],
  },
  {
    nome: "Corporativo",
    descricao: "Para operações maiores e grupos com múltiplas unidades.",
    recursos: ["Até 50 usuários", "Obras ilimitadas", "Todos os módulos disponíveis", "Atendimento via WhatsApp"],
  },
];

const perguntas = [
  ["Preciso instalar algum programa?", "Não. A QualiInfra funciona diretamente no navegador e pode ser acessada em computadores, tablets e celulares."],
  ["Meus dados ficam separados de outras empresas?", "Sim. Cada empresa possui um ambiente isolado, com usuários, permissões e informações próprias."],
  ["Posso usar minha logo nos relatórios?", "Sim. O administrador pode configurar a identidade visual que será aplicada automaticamente aos relatórios."],
  ["Como funciona o atendimento?", "Todo atendimento é realizado via WhatsApp, de forma prática e centralizada."],
];

export default function SiteSaas() {
  const [menuAberto, setMenuAberto] = useState(false);

  function fecharMenu() {
    setMenuAberto(false);
  }

  return (
    <div className="qs-site">
      <header className="qs-header">
        <div className="qs-container qs-nav">
          <a className="qs-brand" href="#inicio" onClick={fecharMenu} aria-label="QualiInfra - início">
            <img className="qs-brand-image" src="/Images/logoSiteSAAS.png" alt="Qualinfra" />
          </a>

          <button
            className="qs-menu-button"
            type="button"
            aria-label="Abrir menu"
            aria-expanded={menuAberto}
            onClick={() => setMenuAberto((aberto) => !aberto)}
          >
            <span /><span /><span />
          </button>

          <nav className={`qs-menu ${menuAberto ? "aberto" : ""}`} aria-label="Navegação principal">
            <a href="#recursos" onClick={fecharMenu}>Recursos</a>
            <a href="#ensaios" onClick={fecharMenu}>Ensaios</a>
            <a href="#sgq" onClick={fecharMenu}>SGQ</a>
            <a href="#como-funciona" onClick={fecharMenu}>Como funciona</a>
            <a href="#planos" onClick={fecharMenu}>Planos</a>
            <a href="#quem-somos" onClick={fecharMenu}>Quem somos</a>
            <a href="#contato" onClick={fecharMenu}>Contato</a>
            <a className="qs-login" href="/app">Entrar</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="qs-hero" id="inicio">
          <div className="qs-hero-glow qs-hero-glow-one" />
          <div className="qs-hero-glow qs-hero-glow-two" />
          <div className="qs-container qs-hero-grid">
            <div className="qs-hero-copy">
              <span className="qs-eyebrow">SGQ na nuvem para engenharia e construção</span>
              <h1>Qualidade que acompanha o ritmo da sua operação.</h1>
              <p>
                Centralize processos, obras, ensaios, indicadores e relatórios em uma plataforma segura,
                simples de usar e preparada para crescer com a sua empresa.
              </p>
              <div className="qs-hero-actions">
                <a className="qs-button qs-button-primary" href="#planos">Conhecer os planos</a>
                <a className="qs-button qs-button-secondary" href="/demonstracao">Solicitar demonstração</a>
              </div>
              <div className="qs-trust-row">
                <span>✓ Atendimento 100% via WhatsApp</span>
                <span>✓ Ambiente seguro</span>
                <span>✓ Acesso em qualquer lugar</span>
              </div>
            </div>

            <div className="qs-hero-visual">
              <img
                src="/Images/site-saas-hero-engenharia.png"
                alt="Profissional de engenharia acompanhando ensaios e indicadores de qualidade"
              />
              <span className="qs-hero-badge badge-cloud"><CloudDoneIcon /><b>SGQ na nuvem</b></span>
              <span className="qs-hero-badge badge-lab"><ScienceIcon /><b>Controle tecnológico</b></span>
            </div>

            <div className="qs-dashboard-showcase">
              <div className="qs-dashboard-intro">
                <span className="qs-kicker">Conheça o ambiente</span>
                <h2>Uma visão clara da qualidade, todos os dias.</h2>
                <p>Acesse rotinas importantes e acompanhe os principais indicadores da empresa em um único painel.</p>
              </div>
              <div className="qs-product-card">
                <img
                  className="qs-dashboard-image"
                  src="/Images/imagemsiteSAAS.png"
                  alt="Painel da plataforma Qualinfra com indicadores de qualidade"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="qs-proof">
          <div className="qs-container">
            <p>Uma plataforma para transformar rotina operacional em informação confiável.</p>
            <div className="qs-proof-numbers">
              <span><b>15+</b><small>tipos de ensaios</small></span>
              <span><b>360°</b><small>da obra ao laudo</small></span>
              <span><b>100%</b><small>acesso pela nuvem</small></span>
              <span><b>1</b><small>ambiente integrado</small></span>
            </div>
          </div>
        </section>

        <section className="qs-section" id="recursos">
          <div className="qs-container">
            <div className="qs-section-heading">
              <span className="qs-kicker">Tudo conectado</span>
              <h2>Menos planilhas. Mais clareza para decidir.</h2>
              <p>A QualiInfra reúne as ferramentas essenciais do SGQ sem complicar a rotina da equipe.</p>
            </div>
            <div className="qs-feature-grid">
              {recursos.map((recurso) => (
                <article className="qs-feature-card" key={recurso.numero}>
                  <div className="qs-feature-icon"><recurso.icone /><span>{recurso.numero}</span></div>
                  <h3>{recurso.titulo}</h3>
                  <p>{recurso.texto}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="qs-section qs-platform" id="plataforma">
          <div className="qs-container">
            <div className="qs-section-heading qs-heading-left">
              <span className="qs-kicker">Uma plataforma, várias frentes</span>
              <h2>Recursos que acompanham a operação do campo à gestão.</h2>
              <p>Os módulos refletem processos reais da engenharia e compartilham clientes, obras, responsáveis e documentos.</p>
            </div>
            <div className="qs-module-grid">
              {modulos.map((modulo) => (
                <article className={`qs-module-card ${modulo.cor}`} key={modulo.titulo}>
                  <div className="qs-module-head"><span><modulo.icone /></span><small>Módulo integrado</small></div>
                  <h3>{modulo.titulo}</h3>
                  <p>{modulo.texto}</p>
                  <ul>{modulo.itens.map((item) => <li key={item}><CheckCircleIcon />{item}</li>)}</ul>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="qs-section qs-tests" id="ensaios">
          <div className="qs-container">
            <div className="qs-section-heading">
              <span className="qs-kicker">Controle tecnológico completo</span>
              <h2>Ensaios organizados do cadastro ao relatório.</h2>
              <p>
                A Qualinfra reúne rotinas de concreto, solos e asfalto em um único ambiente, com dados
                vinculados às obras, rastreabilidade das etapas e resultados prontos para consulta.
              </p>
            </div>

            <div className="qs-tests-showcase">
              <img
                src="/Images/ensaiosSiteSAAS.png"
                alt="Tela da Qualinfra com as categorias e opções de ensaios disponíveis"
              />
            </div>

            <div className="qs-tests-grid">
              <article className="qs-test-card">
                <span><ScienceIcon /></span>
                <div>
                  <h3>Concreto e componentes</h3>
                  <p>Agenda de ruptura, RAA, extrações, resistência à tração, argamassa, módulo de elasticidade, paver e bloco cerâmico.</p>
                </div>
              </article>
              <article className="qs-test-card">
                <span><BallotIcon /></span>
                <div>
                  <h3>Cimento e caracterização</h3>
                  <p>Controle de consistência e tempos de pega, caracterização de materiais e registros técnicos padronizados.</p>
                </div>
              </article>
              <article className="qs-test-card">
                <span><TerrainIcon /></span>
                <div>
                  <h3>Solos e asfalto</h3>
                  <p>Rotinas de campo e laboratório para compactação, densidade in situ, granulometria, adesividade e pavimentação.</p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="qs-section qs-sgq" id="sgq">
          <div className="qs-container">
            <div className="qs-section-heading">
              <span className="qs-kicker">Documentação sob controle</span>
              <h2>Organize o SGQ com rastreabilidade para auditorias e certificações.</h2>
              <p>
                Centralize a documentação do Sistema de Gestão da Qualidade e mantenha os registros
                organizados para apoiar a preparação e a manutenção da ISO 9001 e do PBQP-H.
              </p>
            </div>

            <div className="qs-sgq-showcase">
              <img
                src="/Images/sgqSAAS.png"
                alt="Área de organização e consulta dos documentos do SGQ na Qualinfra"
              />
            </div>

            <div className="qs-sgq-grid">
              <article className="qs-sgq-card">
                <span><DescriptionIcon /></span>
                <h3>Organização por processo</h3>
                <p>Separe manuais, procedimentos e registros por áreas e categorias do SGQ.</p>
              </article>
              <article className="qs-sgq-card">
                <span><RuleIcon /></span>
                <h3>Histórico e controle</h3>
                <p>Acompanhe documentos, versões e atualizações para facilitar consultas e auditorias.</p>
              </article>
              <article className="qs-sgq-card">
                <span><SecurityIcon /></span>
                <h3>Rastreabilidade documental</h3>
                <p>Mantenha os arquivos centralizados e disponíveis conforme os acessos da equipe.</p>
              </article>
            </div>

            <aside className="qs-sgq-note" aria-label="Observação importante sobre os documentos de certificação">
              <RuleIcon />
              <div>
                <strong>Importante: os documentos são responsabilidade do usuário.</strong>
                <p>
                  A Qualinfra não fornece, elabora ou gera automaticamente os documentos exigidos pela
                  ISO 9001 ou pelo PBQP-H. Os conteúdos e arquivos correspondentes devem ser criados,
                  revisados e inseridos pela própria empresa. O sistema oferece somente a logística de
                  organização, armazenamento, consulta e rastreabilidade documental e não garante a certificação.
                </p>
              </div>
            </aside>
          </div>
        </section>

        <section className="qs-section qs-journey">
          <div className="qs-container qs-journey-grid">
            <div className="qs-journey-visual" aria-label="Fluxo integrado da qualidade">
              <div className="qs-flow-core"><DashboardIcon /><b>Qualinfra</b><small>Dados centralizados</small></div>
              <div className="qs-flow-node node-obra"><AddHomeWorkIcon /><span>Obras</span></div>
              <div className="qs-flow-node node-ensaio"><ScienceIcon /><span>Ensaios</span></div>
              <div className="qs-flow-node node-laudo"><DescriptionIcon /><span>Laudos</span></div>
              <div className="qs-flow-node node-sgq"><RuleIcon /><span>SGQ</span></div>
              <i className="qs-flow-ring ring-one" /><i className="qs-flow-ring ring-two" />
            </div>
            <div>
              <span className="qs-kicker">Informação sem retrabalho</span>
              <h2>O dado nasce uma vez e acompanha todo o processo.</h2>
              <p>Cadastros compartilhados reduzem digitação repetida e mantêm consistência entre execução, conferência, aprovação e emissão do relatório.</p>
              <div className="qs-benefit-list">
                <span><CloudDoneIcon /><b>Histórico disponível</b><small>Consulte versões e responsáveis.</small></span>
                <span><SecurityIcon /><b>Acesso por perfil</b><small>Cada usuário vê o que precisa.</small></span>
                <span><QueryStatsIcon /><b>Visão gerencial</b><small>Indicadores atualizados pela operação.</small></span>
              </div>
            </div>
          </div>
        </section>

        <section className="qs-section qs-how" id="como-funciona">
          <div className="qs-container qs-how-grid">
            <div>
              <span className="qs-kicker">Comece com tranquilidade</span>
              <h2>Da configuração ao primeiro relatório em três etapas.</h2>
              <p>A configuração segue um fluxo padronizado, simples e igual para todos os planos.</p>
              <a className="qs-text-link" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">Falar pelo WhatsApp →</a>
            </div>
            <ol className="qs-steps">
              <li><span>1</span><div><strong>Configure sua empresa</strong><p>Cadastre equipe, perfis, clientes e obras.</p></div></li>
              <li><span>2</span><div><strong>Organize os processos</strong><p>Defina os módulos e fluxos usados na rotina.</p></div></li>
              <li><span>3</span><div><strong>Acompanhe os resultados</strong><p>Gere relatórios e monitore indicadores em tempo real.</p></div></li>
            </ol>
          </div>
        </section>

        <section className="qs-section qs-pricing" id="planos">
          <div className="qs-container">
            <div className="qs-section-heading">
              <span className="qs-kicker">Planos transparentes</span>
              <h2>Escolha o melhor ponto de partida.</h2>
              <p>Planos padronizados por porte de operação. Não realizamos modificações personalizadas no sistema.</p>
            </div>
            <div className="qs-pricing-grid">
              {planos.map((plano) => (
                  <article className={`qs-price-card ${plano.destaque ? "destaque" : ""}`} key={plano.nome}>
                    {plano.destaque && <span className="qs-popular">Mais escolhido</span>}
                    <h3>{plano.nome}</h3>
                    <p>{plano.descricao}</p>

                    <div className="qs-price qs-price-consultation">
                      <strong>Em breve</strong>
                    </div>

                    <ul>{plano.recursos.map((item) => <li key={item}>✓ {item}</li>)}</ul>
                    <a
                      className={`qs-button ${plano.destaque ? "qs-button-primary" : "qs-button-outline"}`}
                      href={`/demonstracao?plano=${encodeURIComponent(plano.nome)}`}
                    >
                      Solicitar demonstração
                    </a>
                  </article>
              ))}
            </div>
          </div>
        </section>

        <section className="qs-section qs-about" id="quem-somos">
          <div className="qs-container qs-about-grid">
            <div className="qs-about-visual">
              <div className="qs-orbit qs-orbit-one" /><div className="qs-orbit qs-orbit-two" />
              <div className="qs-about-mark">
                <img src="/Images/logoSiteSAAS.png" alt="Qualinfra" />
              </div>
              <span className="qs-floating-tag tag-one">Engenharia</span>
              <span className="qs-floating-tag tag-two">Tecnologia</span>
              <span className="qs-floating-tag tag-three">Qualidade</span>
            </div>
            <div>
              <span className="qs-kicker">Quem somos</span>
              <h2>Tecnologia criada para quem transforma qualidade em resultado.</h2>
              <p>
                A QualiInfra nasceu da experiência prática em engenharia, controle tecnológico e sistemas de gestão.
                Conhecemos os desafios de manter registros confiáveis, equipes alinhadas e processos auditáveis.
              </p>
              <p>
                Por isso, desenvolvemos uma plataforma que traduz rotinas complexas em fluxos simples, seguros e
                acessíveis para empresas de todos os portes.
              </p>
              <div className="qs-values"><span>Praticidade</span><span>Confiabilidade</span><span>Evolução contínua</span></div>
            </div>
          </div>
        </section>

        <section className="qs-section qs-faq">
          <div className="qs-container qs-faq-grid">
            <div><span className="qs-kicker">Dúvidas frequentes</span><h2>Informação clara antes de começar.</h2></div>
            <div>{perguntas.map(([pergunta, resposta]) => <details key={pergunta}><summary>{pergunta}<span>+</span></summary><p>{resposta}</p></details>)}</div>
          </div>
        </section>

        <section className="qs-contact" id="contato">
          <div className="qs-container qs-contact-inner">
            <div><span className="qs-kicker">Pronto para evoluir?</span><h2>Leve seu sistema de qualidade para o próximo nível.</h2><p>Converse com nossa equipe e veja como a QualiInfra se adapta à sua operação.</p></div>
            <div className="qs-contact-actions">
              <a className="qs-button qs-button-light" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">Falar pelo WhatsApp</a>
              <a className="qs-contact-phone" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">WhatsApp: (63) 99228-1407</a>
              <a href="/app">Já sou cliente →</a>
            </div>
          </div>
        </section>
      </main>

      <footer className="qs-footer">
        <div className="qs-container qs-footer-grid">
          <a className="qs-brand qs-brand-footer" href="#inicio">
            <img className="qs-brand-image" src="/Images/logoSiteSAAS.png" alt="Qualinfra" />
          </a>
          <p>SGQ inteligente para engenharia, laboratórios e construção civil.</p>
          <div><a href="#planos">Planos</a><a href="#quem-somos">Quem somos</a><a href="/app">Acessar sistema</a></div>
        </div>
        <div className="qs-container qs-copyright">© {new Date().getFullYear()} QualiInfra. Todos os direitos reservados.</div>
      </footer>
    </div>
  );
}
